import { Button, Grid, Typography } from "@mui/material";
import { StyledTextField } from "../../../components/StyledComponent/StyledComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postRequest } from "../../../axios/axios";
import {
  handleIsOtpIsValid,
  handleIsEmailVerifyed,
  handleResetPassword,
  saveOtp,
} from "../LoginSlice";
import { toast } from "react-toastify";
const displayClassStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const gridStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};
const grid1Style = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "10px",
};
const resentBtnStyle = {
  color: " #02A0FC",
  textTransform: "none",
  cursor: "pointer",
  "&.MuiButton-root:hover": {
    backgroundColor: "#FFF",
  },
  padding: 0,
  margin: 0,
  marginLeft: "5px",
};
const receiveOtpBtn = {
  marginTop: "5px",
  color: "rgba(0, 0, 0, 0.6)",
  textTransform: "none",
  textAlign: "center",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};
const typoStyle = {
  marginTop: "5px",
  color: "rgba(0, 0, 0, 0.6)",
  textTransform: "none",
  textAlign: "center",
};
const OTPConfirmation = () => {
  const [isOtp, setIsOtp] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isResendOtp, setResendOtp] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);
  const getEmailFromRedux = useSelector((state) => {
    return state?.Login?.userDetail.email;
  });
  const dispatch = useDispatch();

  const handleVerify = async () => {
    const toastId = toast.loading("Loading...");
    try {
      if (isOtp?.length === 0) {
        return toast.error("Enter Verification Code");
      }
      setIsDisabled(true);
      const reqBody = {
        email: getEmailFromRedux,
        otp: isOtp,
      };

      const res = await postRequest(`/api/otp/verify`, reqBody, "sdLogin");
      const { isSuccess, message, data } = res?.data || {};
      if (isSuccess) {
        setIsDisabled(false);
        if (data.isVerified) {
          dispatch(handleIsOtpIsValid(true));
          dispatch(handleIsEmailVerifyed(true));
          dispatch(handleResetPassword(true));
        }
      } else if (!isSuccess) {
        setIsDisabled(false);
        toast.error(message);
      } else {
        setIsDisabled(false);
        toast.error(message);
      }
    } catch (error) {
      setIsDisabled(false);
    } finally {
      toast.dismiss(toastId);
    }
  };
  const handleOnChange = (e) => {
    setIsOtp(e.target.value);
    dispatch(saveOtp(e.target.value));
    setIsDisabled(false);
  };
  const handleResendOTP = async () => {
    const toastId = toast.loading("Loading...");
    try {
      setIsOtp("");
      const reqBody = {
        email: getEmailFromRedux ? getEmailFromRedux : "",
      };
      const res = await postRequest(`/api/email/validate`, reqBody, "sdLogin");
      const { isSuccess } = res?.data || {};
      if (isSuccess) {
        setResendOtp(false);
        setResendTimer(30);
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      toast.dismiss(toastId);
      setResendOtp(false);
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (!isResendOtp && resendTimer > 0) {
        setResendTimer((prevTimer) => prevTimer - 1);
      } else if (resendTimer === 0) {
        setResendOtp(true);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [isResendOtp, resendTimer]);

  return (
    <>
      <Grid
        sx={{ display: "flex", flexDirection: "column", padding: "1rem 2rem" }}
      >
        <Grid item sx={displayClassStyle}>
          <Typography
            variant="h7"
            align="center"
            color="#040F3E"
            sx={{ margin: "0px 0px 10px 0px" }}
          >
            OTP Verification
          </Typography>
        </Grid>
        <Grid item sx={gridStyle}>
          <Typography align="center" variant="caption" sx={typoStyle}>
            {`We have sent an OTP to email ${getEmailFromRedux}. Please enter the code to proceed.`}
          </Typography>
        </Grid>
        <Grid item sm={12} xs={12} sx={{ margin: "20px 0px" }}>
          <StyledTextField
            size="small"
            fullWidth
            name="Enter Verification Code"
            value={isOtp}
            onChange={(e) => handleOnChange(e)}
            label="Enter Verification Code"
          />
        </Grid>
        <Grid item sx={{ textAlign: "center" }}>
          <Button
            variant="contained"
            onClick={handleVerify}
            sx={{ textTransform: "none" }}
            disabled={isDisabled}
          >
            Verify and Proceed
          </Button>
        </Grid>

        <Grid item sx={grid1Style}>
          {isResendOtp && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Typography variant="caption" align="center" sx={receiveOtpBtn}>
                Don't receive an OTP?
                <Button
                  disableElevation
                  disableRipple
                  sx={resentBtnStyle}
                  onMouseEnter={(e) =>
                    (e.target.style.textDecoration = "underline")
                  }
                  onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                  onClick={handleResendOTP}
                >
                  Resend OTP?
                </Button>
              </Typography>
            </div>
          )}
          {!isResendOtp && (
            <Typography
              variant="caption"
              align="center"
              sx={typoStyle}
            ></Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default OTPConfirmation;
